import { useMemo } from "react";

import { LABEL_FIRST_LINE_OFFSET, LABEL_LINE_HEIGHT } from "../constants";
import { wrapLabel } from "../utils";

type Props = {
  x?: string | number;
  y?: string | number;
  payload?: { value?: string };
};

export const CategoryTick: React.FC<Props> = ({ x = 0, y = 0, payload }) => {
  const lines = useMemo(
    () => wrapLabel(payload?.value ?? ""),
    [payload?.value],
  );

  return (
    <g transform={`translate(${x},${y})`}>
      {lines.map((line, i) => (
        <text
          key={line}
          x={0}
          y={LABEL_FIRST_LINE_OFFSET + i * LABEL_LINE_HEIGHT}
          textAnchor="middle"
          fontSize={9.5}
          fill="#6F6C6C"
        >
          {line}
        </text>
      ))}
    </g>
  );
};
